import { Component, Input, OnInit } from '@angular/core';
import { CardComponent } from '../card/card.component';
import { IndicatorData } from 'app/models/indicator.interface';

@Component({
  selector: 'menu-item-card',
  templateUrl: './menu-item-card.component.html',
  styleUrls: ['./menu-item-card.component.scss'],
  standalone: false,
})
export class MenuItemCardComponent extends CardComponent implements OnInit {
  @Input() name = 'Small & Medium Businesses';
  @Input() description = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.';
  @Input() icon: string;
  @Input() indicator?: IndicatorData;
}
